import type { CoinDialogType } from '@/shared/components/dialog/coin/CoinShortageDialog';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface CoinShortageDialogStore {
  /** 대화 상자 노출 여부 */
  open: boolean;
  /** 결제 플랜 식별자 */
  planId?: number;
  /** 대화 상자 표현 타입 */
  type?: CoinDialogType;
}

export interface CoinShortageDialogStoreActions {
  /** 대화 상자 열림 상태를 설정한다. */
  setOpen: (open: boolean) => void;
  /** 결제 플랜 식별자를 설정한다. */
  setPlanId: (planId: number) => void;
  /** 대화 상자 타입을 설정한다. */
  setType: (type: CoinDialogType) => void;
  setDialogData: (payload: {
    open: boolean;
    planId?: number;
    type?: CoinDialogType;
  }) => void;
  reset: () => void;
}

/**
 * 코인 부족 대화 상자의 상태와 액션을 제공하는 스토어
 */
export const useCoinShortageDialogStore = create<
  CoinShortageDialogStore & CoinShortageDialogStoreActions
>()(
  devtools((set) => ({
    open: false,
    planId: undefined,
    type: undefined,
    setOpen: (open: boolean) => set({ open }),
    setPlanId: (planId: number) => set({ planId }),
    setType: (type: CoinDialogType) => set({ type }),
    setDialogData: (payload) => set({ ...payload }),
    reset: () => set({ open: false, planId: undefined, type: undefined }),
  })),
);
